// @flow strict

import * as React from 'react';
import cx from 'classnames';
// eslint-disable-next-line css-modules/no-unused-class
import styles from './styles.scss';
import PageContentBlock from '../../internal/PageContentBlock';
import { Link } from '../../internal/Button';
import ResponsiveImage from '../../internal/ResponsiveImage';

type CtaButton = {
  text: string,
  href: string,
};

export type PropTypes = {
  title: string,
  subtitle: string,
  variant: 'Large' | 'Medium' | 'Small',
  alignment: 'Left' | 'Center',
  background?: 'Featured' | 'Dark' | 'Silver' | 'Crystal' | 'White',
  image: string,
  firstCta?: CtaButton,
  secondCta?: CtaButton,
  noBottomPadding?: boolean,
};

const backgroundButtonMapping = {
  Featured: {
    First: 'Default',
    Second: 'GhostInverse',
  },
  Dark: {
    First: 'DefaultInverse',
    Second: 'Ghost',
  },
  Silver: {
    First: 'Default',
    Second: 'GhostInverse',
  },
  Crystal: {
    First: 'Default',
    Second: 'GhostInverse',
  },
  White: {
    First: 'Default',
    Second: 'GhostInverse',
  },
};

const Alignment = {
  Left: 'Left',
  Center: 'Center',
};

const Variant = {
  Large: 'Large',
  Medium: 'Medium',
  Small: 'Small',
};

const Header = (props: PropTypes) => {
  const leftStyle = props.alignment === Alignment.Left && styles.isLeft;
  return (
    <PageContentBlock
      className={cx([styles.header, leftStyle])}
      image={props.alignment !== Alignment.Left ? props.image : undefined}
      background={props.alignment === Alignment.Left ? props.background : 'Default'}
    >
      <div
        className={cx(
          styles.container,
          styles[`is${props.variant}`],
          leftStyle,
          props.noBottomPadding && styles.noBottomPadding,
        )}
      >
        <h1 className={cx([styles.title, styles[`is${props.variant}`], leftStyle])}>
          {props.title}
        </h1>
        <p
          className={cx([
            styles.subtitle,
            styles[`is${props.variant}`],
            props.alignment === Alignment.Left && styles.isLeft,
          ])}
        >
          {props.subtitle}
        </p>
        {props.firstCta && !props.secondCta && (
          <Link
            variant={
              props.background ? backgroundButtonMapping[props.background].First : 'DefaultInverse'
            }
            href={props.firstCta.href}
            size={props.variant === 'Large' ? 'Medium' : props.variant}
          >
            {props.firstCta.text}
          </Link>
        )}
        {props.firstCta && props.secondCta && (
          <div className={styles.buttonContainer}>
            <Link
              className={styles.ctaBtn}
              variant={
                props.background ? backgroundButtonMapping[props.background].First : 'Default'
              }
              href={props.firstCta.href}
              size={Variant.Small}
            >
              {props.firstCta.text}
            </Link>
            <Link
              className={styles.ctaBtn}
              variant={
                props.background ? backgroundButtonMapping[props.background].Second : 'GhostInverse'
              }
              href={props.secondCta.href}
              size={Variant.Small}
            >
              {props.secondCta.text}
            </Link>
          </div>
        )}
        {props.alignment === 'Left' && (
          <ResponsiveImage
            className={cx(styles.image, props.noBottomPadding && styles.noBottomPadding)}
            src={props.image}
            alt={props.title}
            defaultSize={{ width: 700 }}
            srcSet={[
              { mediaMaxWidth: 1000, width: 500 },
              { mediaMaxWidth: 767, width: 767 },
              { mediaMaxWidth: 600, width: 600 },
              { mediaMaxWidth: 400, width: 400 },
            ]}
          />
        )}
      </div>
    </PageContentBlock>
  );
};

Header.defaultProps = {
  variant: 'Large',
  alignment: 'Center',
  noBottomPadding: false,
};

export default Header;
